/**
 * Constants shared across multiple projects (api, react, crawler, mcp)
 */

export const MAX_SEARCH_ITEMS = 6;
export const SEARCH_DEFAULT_ROWS_PER_PAGE = 25;
export const SEARCH_MAX_REGISTERED_UNOBFUSCATED_ROWS = 100;
export const SEARCH_MAX_GUEST_UNOBFUSCATED_ROWS = 50;
export const HEADER_USER_UUID = 'nd-user-uuid';

export const LANDING_PAGE_COOKIE_KEY = 'nd.landingpage';
export const REFERRER_COOKIE_KEY = 'nd.document.referrer';
export const GOOGLE_SEARCH_TEXT_COOKIE_KEY = 'nd.googlesearchtext';
export const ANONYMOUS_USER_UUID_COOKIE_NAME = 'nd.auid';
export const EXTENSION_INSTALLED_COOKIE_NAME = 'nd.extension';
export const SESSION_HASH_EXPIRED_ERROR_CODE = 'session-expired';
export const DOMAIN_NOT_FOUND_ERROR_CODE = 'domain-not-found';
export const COOKIE_FEATURES_OVERRIDE = 'x-nd-features-override';

// Default monthly API/MCP credits for every registered account (api_credits.monthly_credits overrides)
export const API_FREE_MONTHLY_CREDITS = 500;
export const HEADER_API_CREDITS_REMAINING = 'x-nd-credits-remaining';
